// extracted by mini-css-extract-plugin
export var modal = "_uq-0";
export var table = "_uq-1";